/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// tricky hack for quick fix an issue with duplicating change events for payment options inputs. Would be great to fix logical issues but I didn't have enough time for that.
let areChangeEventsAttachedToPaymentOptionsFlag = false;
//will be used across for identify heat-pump
const template = window.theme ? window.theme.template : null;


function setCookie(cName, cValue, expDays) {
  let date = new Date();
  date.setTime(date.getTime() + (expDays * 24 * 60 * 60 * 1000));
  const expires = "expires=" + date.toUTCString();
  document.cookie = cName + "=" + cValue + "; " + expires + "; path=/";
}

const openPopupButtonEl = document.getElementById('openPopupBtn');
const addressFieldEl = document.getElementById('pac-input');
let customerLocationArray = [];
function initMap() {
  // Create a meausure object to store our markers, MVCArrays, lines and polygons
  var measure = {
    mvcLine: new google.maps.MVCArray(),
    mvcPolygon: new google.maps.MVCArray(),
    mvcMarkers: new google.maps.MVCArray(),
    line: null,
    polygon: null
  };


  let map = new google.maps.Map(document.getElementById("map"), {
    zoom: 18,
    mapTypeControl: false,
    mapTypeId: "satellite",
    streetViewControl: false,
    center: new google.maps.LatLng(52.521919, 13.413215),
    draggableCursor: "crosshair" // Make the map cursor a crosshair so the user thinks they should click something
  });


  var errorMessage = document.getElementById("error-message");
  const card = document.getElementById("pac-card");
  const input = document.getElementById("pac-input");
  const houseNumberInput = document.getElementById("house_number_input");
  var accordion_btn = card.querySelector(".faq__question");
  var accordion_answer = card.querySelector(".faq__answer-wrapper");
  var address_question = document.getElementById("address_question")
  var meassure_instructions_question = document.getElementById("meassure_instructions_question")
  var adress_instructions_answer = document.querySelector(".adress_instructions_answer")
  var meassure_instructions_answer = document.querySelector(".meassure_instructions_answer")
  var Tooltip_wrapper = document.querySelector(".Tooltip_wrapper")
  var tooltipSettingsData = document.querySelector('[data-popup-settings]');
  var map_wrapper_div = document.querySelector(".map-wrapper");
  var togglekw_yearly = document.getElementById("toggle-kw-yearly")
  var popupPDP = document.querySelector(".popupPDP");
  if (popupPDP) {
    var modal__dialog = popupPDP.querySelector(".modal__dialog");
  }
  var checkMarkIcon = document.querySelector(".pac-input-check-icon");

  // function to check if mobile screen to scrool to element 
  function smoothScrollTo(element, container, speed) {
    const isMobilescreen = window.matchMedia("(max-width: 900px)").matches;
    if (isMobilescreen) {
      const containerScrollTop = container.scrollTop;
      const startPos = containerScrollTop;
      let targetPos = element.offsetTop - container.offsetTop;
      if (element.classList.contains('meassure_instructions_answer')) {
        targetPos = targetPos - 60;
      }
      else if (element.classList.contains('faq__question')) {
        targetPos = targetPos - 275;
      }
      else if (element.classList.contains('adress_instructions_answer')) {
        targetPos = targetPos - 135;
      }
      const distance = targetPos - startPos;
      const startTime = performance.now();
      function scrollAnimation(currentTime) {
        const elapsedTime = currentTime - startTime;
        const progress = Math.min(elapsedTime / speed, 1);
        container.scrollTop = startPos + distance * progress;

        if (progress < 1) {
          requestAnimationFrame(scrollAnimation);
        }
      }
      requestAnimationFrame(scrollAnimation);
    }
  }
  // smoothScrollTo adress_instructions_answer wrapper once user focus on adress input 
  if (input) {
    input.addEventListener('focus', function (event) {
      smoothScrollTo(adress_instructions_answer, modal__dialog, 700)
    });
  }

  const options = {
    fields: ["formatted_address", "geometry", "name"],
    strictBounds: false,
    types: ['geocode'], // Restrict to geocoding results
    componentRestrictions: { country: 'DE' },// Restrict to Germany
    bounds: { // Set bounds to a region that excludes German islands
      //  pounds for mainland of Germany 
      south: 47.2, // Southernmost point
      west: 5.5,   // Westernmost point
      north: 54.9, // Northernmost point
      east: 15.2   // Easternmost point
    }
  };



  const autocomplete = new google.maps.places.Autocomplete(input, options);

  // Bind the map's bounds (viewport) property to the autocomplete object,
  // so that the autocomplete requests use the current map bounds for the
  // bounds option in the request.
  autocomplete.bindTo("bounds", map);

  const infowindow = new google.maps.InfoWindow();
  const infowindowContent = document.getElementById("infowindow-content");

  infowindow.setContent(infowindowContent);


  autocomplete.addListener("place_changed", () => {
    var address = input.value.trim();
    var buildingNumberRegex = /^[^\d]+\d+\b/;
    // function to handle address input Regex not accept untile user add building number 
    if (buildingNumberRegex.test(address)) {

      infowindow.close();
      const place = autocomplete.getPlace();
      if (!place.geometry || !place.geometry.location) {
        // User entered the name of a Place that was not suggested and
        // pressed the Enter key, or the Place Details request failed.
        //window.alert("No details available for input: '" + place.name + "'");
        return;
      }

      // If the place has a geometry, then present it on a map.
      if (place.geometry.viewport) {
        map.fitBounds(place.geometry.viewport);

        // add geoCoordinates of the place to sessionStorage
        var geoCoordinates = {}
        geoCoordinates = { lat: place.geometry.location.lat(), lng: place.geometry.location.lng() }
        sessionStorage.setItem("geoCoordinates", JSON.stringify(geoCoordinates))

        var mapOverlay = document.querySelector(".map-overlay");
        if (!!mapOverlay) {
          mapOverlay.style.display = "none";
        }
        dataLayer.push({
          'event': 'customEvent',  // Event name
          'category': `address_entered`  // address_entered
        });
        console.log("dataLayer", dataLayer)

        window.scrollTo(0, 0);
        // adding address input value to sessionStorage
        var address_input = document.querySelector("#pac-input");
        if (!!address_input) {
          sessionStorage.setItem(`${address_input.getAttribute('id')}`, `${address_input.value}`);
        }
      } else {
        map.setCenter(place.geometry.location);
        map.setZoom(17);

      }
      // function to collect more data like [zipcode,street, bulding number] from address and add it to sessionStorage 
      var addressInputValue = address_input.value
      if (addressInputValue) {
        geocoder = new google.maps.Geocoder();
        geocoder.geocode({ 'address': addressInputValue }, function (results, status) {
          if (results && status == "OK") {
            var addressComponents = results[0].address_components
            if (addressComponents) {
              addressComponents.forEach(component => {
                if (component.types[0] == "postal_code") {
                  sessionStorage.setItem(`zipcode`, `${component.long_name}`);
                }
                else if (component.types[0] == "route") {
                  sessionStorage.setItem(`installation_address_street`, `${component.long_name}`);
                }
                else if (component.types[0] == "street_number") {
                  sessionStorage.setItem(`installation_address_street_number`, `${component.long_name}`);
                }
                else if (component.types[0] == "locality") {
                  sessionStorage.setItem(`installation_address_city`, `${component.long_name}`);
                }
                else if (component.types[0] == "country") {
                  sessionStorage.setItem(`installation_address_country`, `${component.long_name}`);
                }
                else if (component.types[0] == "administrative_area_level_1") {
                  sessionStorage.setItem(`installation_address_state`, `${component.long_name}`);
                }
              });
            }
          }
        });
      }


      // hide error message if address have building number 
      input.style.borderColor = "rgb(198, 198, 198)";
      errorMessage.style.display = "none"
      houseNumberInput.style.display = "none"
      input.setAttribute("addressHasNumber", "true")
      infowindow.open(map);
      map.setZoom(20);
      map.setTilt(0);

      // show checkmark 
      if (checkMarkIcon) {
        checkMarkIcon.classList.remove("hidden");
      }
      // This step to close first address question Collapsible and open the second measure instructions question Collapsible
      if (address_question && adress_instructions_answer) {
        address_question.setAttribute("aria-expanded", "false");
        meassure_instructions_question.setAttribute("aria-expanded", "true");
        adress_instructions_answer.style.height = 0;
        meassure_instructions_answer.style.height = "auto";
        Tooltip_wrapper.classList.add("firstStepStyle");
        // change text in tooltip on map 
        if (tooltipSettingsData) {
          var tooltipSettingsDataObject = JSON.parse(tooltipSettingsData.getAttribute("data-popup-settings"));
          Tooltip_wrapper.innerText = tooltipSettingsDataObject.no_point_selected
        }
        map_wrapper_div.classList.remove("showMap");
        smoothScrollTo(meassure_instructions_answer, modal__dialog, 700)
      }

      // function to get section settings for add label to the customer location marker or no
      let popSettingsData = document.querySelector("#popups-from-data");
      let addLabel = "";
      if (popSettingsData) {
        let sectionSettings = JSON.parse(popSettingsData?.textContent)
        if (sectionSettings.locationMarkerLabel) {
          addLabel = addressInputValue;
        }
      }

      // check if there's any markers and remove it before add new one 
      if (customerLocationArray.length > 0) {
        customerLocationArray.forEach(function (elem, index) {
          elem.setMap(null);
        });
      }
      // add marker of the customer location and his address on the map
      var marker = new google.maps.Marker({
        map: map,
        position: place.geometry.location,
        draggable: false,
        raiseOnDrag: false,
        label: `${addLabel}`,
        title: "customer location"
      });
      customerLocationArray.push(marker);

    } else {
      // show error message if address without building number , and disable continueBtn
      continueBtn.setAttribute("isallchange", "false");
      input.style.borderColor = "red";
      errorMessage.style.display = "block"
      houseNumberInput.style.display = "block"
      input.setAttribute("addressHasNumber", "false")
      // this to handle if user didn't add house number so we show other input to add house number and search again
      houseNumberInput.classList.add("outline_focus")
      houseNumberInput.addEventListener("keyup", function () {
        if (this.value != "") {
          var addressinputValue = input.value;
          setTimeout(function () {
            var houseNumberInputValue = houseNumberInput.value
            let index = addressinputValue.indexOf(",");
            let modifiedAddress = "";
            if (index) {
              let hasNumbersBeforeComma = /^\D*\d/.test(addressinputValue);
              if (hasNumbersBeforeComma) {
                modifiedAddress = address.replace(/^\D*([\d,]+)\s*,/, '');
                modifiedAddress = modifiedAddress.trim();
                index = modifiedAddress.indexOf(",");
                modifiedAddress = modifiedAddress.slice(0, index) + " " + houseNumberInputValue + modifiedAddress.slice(index);
              } else {
                modifiedAddress = addressinputValue.slice(0, index) + " " + houseNumberInputValue + addressinputValue.slice(index);
              }
            } else {
              modifiedAddress = `${houseNumberInputValue} ${addressinputValue}`;
            }
            input.value = modifiedAddress;
            houseNumberInput.classList.remove("outline_focus")
            input.focus();
          }, 1000);
        }
      })
    }
  });



  google.maps.event.addListener(map, "click", function (evt) {
    // When the map is clicked, pass the LatLng obect to the measureAdd function
    measureAdd(evt.latLng);
  });
  // this function to show and hide map with click on meassure_instructions_question
  meassure_instructions_question.addEventListener("click", function () {
    if (this.getAttribute("aria-expanded") == "false") {
      map_wrapper_div.classList.remove("showMap")
    } else {
      map_wrapper_div.classList.add("showMap")
    }
  })
  function measureAdd(latLng) {
    // this to check if it's first mark to add green color 
    if (measure.mvcLine.getLength() == 0) {
      sessionStorage.setItem("firstDotLat", latLng.lat())
      sessionStorage.setItem("firstDotLng", latLng.lng())
      var marker = new google.maps.Marker({
        map: map,
        position: latLng,
        draggable: true,
        raiseOnDrag: false,
        title: "Drag me to change shape first one",
        icon: new google.maps.MarkerImage("https://cdn.shopify.com/s/files/1/0591/8372/6636/files/red-circle-png-32245.png?v=1696944481", new google.maps.Size(9, 9), new google.maps.Point(0, 0), new google.maps.Point(5, 5))
      });
      // function to update firstDotLat and firstDotLng in sessionStorage to make sure only first dot is close the polygon shapes
      google.maps.event.addListener(marker, "dragend", function (evt) {
        sessionStorage.setItem("firstDotLat", evt.latLng.lat())
        sessionStorage.setItem("firstDotLng", evt.latLng.lng())
      })
    } else {
      // Add a draggable marker to the map where the user clicked
      var marker = new google.maps.Marker({
        map: map,
        position: latLng,
        draggable: true,
        raiseOnDrag: false,
        title: "Drag me to change shape",
        icon: new google.maps.MarkerImage("https://cdn.shopify.com/s/files/1/0591/8372/6636/files/red-circle-png-32245.png?v=1696944481", new google.maps.Size(9, 9), new google.maps.Point(0, 0), new google.maps.Point(5, 5))
      });

    }
    // Add this LatLng to our line and polygon MVCArrays
    // Objects added to these MVCArrays automatically update the line and polygon shapes on the map
    measure.mvcLine.push(latLng);
    measure.mvcPolygon.push(latLng);

    // Push this marker to an MVCArray
    // This way later we can loop through the array and remove them when measuring is done
    measure.mvcMarkers.push(marker);

    // Get the index position of the LatLng we just pushed into the MVCArray
    // We'll need this later to update the MVCArray if the user moves the measure vertexes
    var latLngIndex = measure.mvcLine.getLength() - 1;

    // When the user mouses over the measure vertex markers, change shape and color to make it obvious they can be moved
    google.maps.event.addListener(marker, "mouseover", function () {
      marker.setIcon(new google.maps.MarkerImage("https://cdn.shopify.com/s/files/1/0591/8372/6636/files/red-circle-png-32245.png?v=1696944481", new google.maps.Size(15, 15), new google.maps.Point(0, 0), new google.maps.Point(8, 8)));
    });

    // Change back to the default marker when the user mouses out
    google.maps.event.addListener(marker, "mouseout", function () {
      marker.setIcon(new google.maps.MarkerImage("https://cdn.shopify.com/s/files/1/0591/8372/6636/files/red-circle-png-32245.png?v=1696944481", new google.maps.Size(9, 9), new google.maps.Point(0, 0), new google.maps.Point(5, 5)));
    });

    google.maps.event.addListener(marker, "click", function (evt) {
      var firstDotLat = Number(sessionStorage.getItem("firstDotLat"));
      var firstDotLng = Number(sessionStorage.getItem("firstDotLng"));
      if (measure.mvcLine.getLength() > 2 && firstDotLat == evt.latLng.lat() && firstDotLng == evt.latLng.lng()) {
        measureAdd(evt.latLng);
        // Create the polygon (google.maps.Polygon)
        measure.polygon = new google.maps.Polygon({
          clickable: false,
          map: map,
          fillOpacity: 0.25,
          strokeOpacity: 0,
          paths: measure.mvcPolygon
        });
        measureCalc();
        // add sessionStorage isMapDotesDone true
        sessionStorage.setItem("isMapDotesDone", true);
        // check we have all tooltip text from section settings and once user click last Polygon checng text and style and hide map
        if (tooltipSettingsData) {
          var tooltipSettingsDataObject = JSON.parse(tooltipSettingsData.getAttribute("data-popup-settings"));
          Tooltip_wrapper.classList.add("doneStepStyle")
          map_wrapper_div.classList.add("showMap")
          smoothScrollTo(togglekw_yearly, modal__dialog, 700)
          Tooltip_wrapper.innerText = tooltipSettingsDataObject.polygon_done
        }

        if (meassure_instructions_question && meassure_instructions_answer) {
          meassure_instructions_question.setAttribute("aria-expanded", "false");
          meassure_instructions_answer.style.height = 0;
        }
        document.dispatchEvent(new CustomEvent("popup:map:ready"));
      }
    });

    // When the measure vertex markers are dragged, update the geometry of the line and polygon by resetting the
    //     LatLng at this position
    google.maps.event.addListener(marker, "drag", function (evt) {
      measure.mvcLine.setAt(latLngIndex, evt.latLng);
      measure.mvcPolygon.setAt(latLngIndex, evt.latLng);
    });

    // When dragging has ended and there is more than one vertex, measure length, area.
    google.maps.event.addListener(marker, "dragend", function () {
      if (measure.mvcLine.getLength() > 1) {
        measureCalc();
      }
    });

    if (measure.mvcLine.getLength() < 2) {
      // check of first dot on map add text to tooltip
      if (tooltipSettingsData) {
        var tooltipSettingsDataObject = JSON.parse(tooltipSettingsData.getAttribute("data-popup-settings"));
        Tooltip_wrapper.innerText = tooltipSettingsDataObject.one_2_points_selected
      }
      dataLayer.push({
        'event': 'customEvent',  // Event name
        'category': `first_dot_on_map`  // Custom data
      });
      console.log("dataLayer", dataLayer)

    }
    // check of third dot on map add text to tooltip
    if (measure.mvcLine.getLength() == 3) {
      if (tooltipSettingsData) {
        var tooltipSettingsDataObject = JSON.parse(tooltipSettingsData.getAttribute("data-popup-settings"));
        Tooltip_wrapper.innerText = tooltipSettingsDataObject.moreThanTwo_points_selected
      }
    }

    // If there is more than one vertex on the line
    if (measure.mvcLine.getLength() > 1) {

      // If the line hasn't been created yet
      if (!measure.line) {

        // Create the line (google.maps.Polyline)
        measure.line = new google.maps.Polyline({
          map: map,
          clickable: true,
          strokeColor: "#f4c013",
          strokeOpacity: 1,
          strokeWeight: 4,
          path: measure.mvcLine
        });

      }

      // If there is more than two vertexes for a polygon
      if (measure.mvcPolygon.getLength() > 2) {

        // If the polygon hasn't been created yet
        if (!measure.polygon) {
          // Create the polygon (google.maps.Polygon)
          measure.polygon = new google.maps.Polygon({
            clickable: false,
            map: map,
            fillOpacity: 0.25,
            strokeOpacity: 0
          });

        }

      }

    }

    // If there's more than one vertex, measure length, area.
    if (measure.mvcLine.getLength() > 1) {
      measureCalc();
    }

  }

  function measureCalc() {
    // If we have a polygon (>2 vertexes in the mvcPolygon MVCArray)
    if (measure.mvcPolygon.getLength() > 2) {
      // Use the Google Maps geometry library to measure the area of the polygon
      var area = google.maps.geometry.spherical.computeArea(measure.polygon.getPath());
      var areaSpan = document.getElementById("span-area");
      areaSpan.innerText = area.toFixed(1)
      checkInputs()
      // adding areaSpan value to sessionStorage
      if (!!areaSpan && areaSpan.innerText > 0) {
        sessionStorage.setItem(`roof_area`, `${areaSpan.innerText}`);
      }
    }
  }

  function measureReset() {
    // If we have a polygon or a line, remove them from the map and set null
    if (measure.polygon) {
      measure.polygon.setMap(null);
      measure.polygon = null;
    }

    if (measure.line) {
      measure.line.setMap(null);
      measure.line = null;
    }

    // Empty the mvcLine and mvcPolygon MVCArrays
    measure.mvcLine.clear();
    measure.mvcPolygon.clear();

    // Loop through the markers MVCArray and remove each from the map, then empty it
    measure.mvcMarkers.forEach(function (elem, index) {
      elem.setMap(null);
    });

    measure.mvcMarkers.clear();

    var areaSpan = document.getElementById("span-area");
    var lengthSpan = document.getElementById("span-length");
    areaSpan.innerText = "0";
    lengthSpan.innerText = "";
    if (accordion_btn) {
      accordion_btn.setAttribute("aria-expanded", "true");
      accordion_answer = document.querySelector(".faq__answer-wrapper");
      if (!!accordion_answer) {
        accordion_answer.style.height = "auto";
      }

    }
    document.dispatchEvent(new CustomEvent("popup:map:reset"));

  }
  const popupContinueBtn = document.getElementById('continueBtn');
  popupContinueBtn?.addEventListener('click', () => {
    var isMapDotesDone = sessionStorage.getItem("isMapDotesDone");
    if (isMapDotesDone == false || isMapDotesDone == null || isMapDotesDone == undefined) {
      measureReset()
      sessionStorage.setItem('roof_area', 0);
      if (tooltipSettingsData) {
        var tooltipSettingsDataObject = JSON.parse(tooltipSettingsData.getAttribute("data-popup-settings"));
        Tooltip_wrapper.classList.remove("doneStepStyle")
        Tooltip_wrapper.innerText = tooltipSettingsDataObject.no_point_selected
      }
    }
  })

  var resetLines = document.getElementById("resetLines");
  resetLines.addEventListener("click", function () {
    measureReset()
    sessionStorage.setItem('roof_area', 0);
    if (tooltipSettingsData) {
      var tooltipSettingsDataObject = JSON.parse(tooltipSettingsData.getAttribute("data-popup-settings"));
      Tooltip_wrapper.classList.remove("doneStepStyle")
      Tooltip_wrapper.innerText = tooltipSettingsDataObject.no_point_selected
    }
    if (meassure_instructions_question && meassure_instructions_answer) {
      meassure_instructions_question.setAttribute("aria-expanded", "true");
      meassure_instructions_answer.style.height = "auto";
    }
  })
  var openPopupBtn = document.getElementById("openPopupBtn")
  if (!!openPopupBtn) {
    openPopupBtn.addEventListener('click', function () {
      measureReset()
    })
    document.dispatchEvent(new CustomEvent("popup:reset"));
  }

  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape" || event.keyCode === 27) {
      measureReset()
    }
  });


  // PDP,  function to check if url have Address Parameters to get the adress detiels from google api and add to to sessionStorage
  function checkAndStoreAdressParameters() {
    let lat = ""
    let lng = ""
    const requiredParameters = [
      'lat',
      'lng'
    ];
    var isAddressStored = false
    if (sessionStorage.getItem("pac-input") != null) {
      isAddressStored = true
    }
    const currentUrl = window.location.href;
    // Extract parameters from the URL
    const urlParams = new URLSearchParams(currentUrl.split('?')[1]);
    // go through urlParams and add lat and lng to var to start get adress 
    requiredParameters.forEach(param => {
      if (!urlParams.has(param) || sessionStorage.getItem(param) === null) {
        const paramValue = urlParams.get(param);
        if (paramValue) {
          if (param == "lat") {
            lat = paramValue
          }
          else if (param == "lng") {
            lng = paramValue
          }
        }
      }
    });

    if (lat && lng && !isAddressStored) {
      const latlngParam = {
        lat: Number(lat),
        lng: Number(lng)
      };
      sessionStorage.setItem("geoCoordinates", JSON.stringify(latlngParam));
      let AdressFromlatlngParam = ""
      geocoder = new google.maps.Geocoder();
      geocoder.geocode({ location: latlngParam })
        .then((response) => {
          if (response.results[0]) {
            AdressFromlatlngParam = response.results[0].formatted_address
            sessionStorage.setItem("pac-input", AdressFromlatlngParam);
            if (AdressFromlatlngParam) {
              geocoder.geocode({ 'address': AdressFromlatlngParam }, function (results, status) {
                if (results && status == "OK") {
                  var addressComponents = results[0].address_components
                  if (addressComponents) {
                    addressComponents.forEach(component => {
                      if (component.types[0] == "postal_code") {
                        sessionStorage.setItem(`zipcode`, `${component.long_name}`);
                      }
                      else if (component.types[0] == "route") {
                        sessionStorage.setItem(`installation_address_street`, `${component.long_name}`);
                      }
                      else if (component.types[0] == "street_number") {
                        sessionStorage.setItem(`installation_address_street_number`, `${component.long_name}`);
                      }
                      else if (component.types[0] == "locality") {
                        sessionStorage.setItem(`installation_address_city`, `${component.long_name}`);
                      }
                      else if (component.types[0] == "country") {
                        sessionStorage.setItem(`installation_address_country`, `${component.long_name}`);
                      }
                      else if (component.types[0] == "administrative_area_level_1") {
                        sessionStorage.setItem(`installation_address_state`, `${component.long_name}`);
                      }
                    });
                  }
                }
              });
            }

          }
        })
        .catch((e) => console.log("Geocoder failed due to: " + e));
    }

  }
  // Call the function when the page loads to check and store parameters
  checkAndStoreAdressParameters();
}

window.initMap = initMap;

function removeAddressOutline(addressEl) {
  const inputOutline = addressEl.dataset.outline;

  // Remove outline if input filled
  if (addressInput.value.trim() !== '') {
    addressInput.dataset.outline = false;
  }

  // Remove outline on input event
  if (inputOutline === 'true') {
    addressInput.addEventListener('input', function () {
      addressInput.dataset.outline = false;
    });
  }
}

function initMapHeatpump() {
  // Create a meausure object to store our markers, MVCArrays, lines and polygons
  var measure = {
    mvcLine: new google.maps.MVCArray(),
    mvcPolygon: new google.maps.MVCArray(),
    mvcMarkers: new google.maps.MVCArray(),
    line: null,
    polygon: null
  };

  let map = new google.maps.Map(document.getElementById("map"), {
    zoom: 18,
    mapTypeControl: false,
    streetViewControl: false,
    center: new google.maps.LatLng(52.521919, 13.413215)
  });


  const card = document.getElementById("pac-card");
  const input = document.getElementById("pac-input");
  const questionElement = input.closest('.question-container');


  const options = {
    fields: ["formatted_address", "geometry", "name", "address_components"],
    strictBounds: false,
    types: ['address'], // Restricting results to addresses
    componentRestrictions: { country: 'DE' },// Restrict to Germany
    bounds: { // Set bounds to a region that excludes German islands
      //  pounds for mainland of Germany
      south: 47.2, // Southernmost point
      west: 5.5,   // Westernmost point
      north: 54.9, // Northernmost point
      east: 15.2   // Easternmost point
    }
  };



  const autocomplete = new google.maps.places.Autocomplete(input, options);

  // Bind the map's bounds (viewport) property to the autocomplete object,
  // so that the autocomplete requests use the current map bounds for the
  // bounds option in the request.
  autocomplete.bindTo("bounds", map);

  const infowindow = new google.maps.InfoWindow();
  const infowindowContent = document.getElementById("infowindow-content");
  const inputSuccessCheckIcon = document.querySelector('.pac-input-check-icon');
  const errorMessage = document.getElementById("error-message");

  infowindow.setContent(infowindowContent);



  autocomplete.addListener("place_changed", () => {
    infowindow.close();


    const place = autocomplete.getPlace();
    // Post-selection validation to check for street number
    if (!place.address_components) {
      if (inputSuccessCheckIcon) {
        inputSuccessCheckIcon.classList.add('hidden')
      }
      errorMessage.style.display = 'block'
      input.style.border = "2px solid red";
      questionElement.dataset.valid = false;
      return;
    }

    var hasStreetNumber = place.address_components.some(function (component) {
      return component.types.includes('street_number');
    });

    if (!hasStreetNumber) {
      if (inputSuccessCheckIcon) {
        inputSuccessCheckIcon.classList.add('hidden')
      }
      errorMessage.style.display = 'block'
      input.style.border = "2px solid red";
      questionElement.dataset.valid = false;
      return;
    }

    errorMessage.style.display = 'none'
    input.style.border = "1px solid #C6C6C6";


    if (!place.geometry || !place.geometry.location) {
      // User entered the name of a Place that was not suggested and
      // pressed the Enter key, or the Place Details request failed.
      //window.alert("No details available for input: '" + place.name + "'");
      errorMessage.style.display = 'block'
      input.style.border = "2px solid red";
      questionElement.dataset.valid = false;
      return;
    }

    questionElement.dataset.valid = true;
    questionElement.dataset.values = JSON.stringify(place);

    if (inputSuccessCheckIcon) {
      inputSuccessCheckIcon.classList.remove('hidden')
    }

    // If the place has a geometry, then present it on a map.
    if (place.geometry.viewport) {
      map.fitBounds(place.geometry.viewport);

      // add geoCoordinates of the place to sessionStorage
      var geoCoordinates = {}
      geoCoordinates = { lat: place.geometry.location.lat(), lng: place.geometry.location.lng() }
      sessionStorage.setItem("geoCoordinates", JSON.stringify(geoCoordinates))

      var mapOverlay = document.querySelector(".map-overlay");
      if (!!mapOverlay) {
        mapOverlay.style.display = "none";
      }

      new google.maps.Marker({
        position: geoCoordinates,
        map
      });
      window.scrollTo(0, 0);
      // adding address input value to sessionStorage
      var address_input = document.querySelector("#pac-input");
      if (!!address_input) {
        sessionStorage.setItem(`${address_input.getAttribute('id')}`, `${address_input.value}`);
      }
    } else {
      map.setCenter(place.geometry.location);
      map.setZoom(17);

    }


    infowindow.open(map);
    map.setZoom(19);
    map.setTilt(0);

  });






  var openPopupBtn = document.getElementById("openPopupBtn")
  if (!!openPopupBtn) {
    openPopupBtn.addEventListener('click', function () {
      //measureReset()
    })
    document.dispatchEvent(new CustomEvent("popup:reset"));
  }

  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape" || event.keyCode === 27) {
      //measureReset()
    }
  });
}

window.initMapHeatpump = initMapHeatpump;


// function to check all inputs in popup Form have value
var addressInput = document.getElementById("pac-input")
var meassure_instructions = document.querySelector(".meassure_instructions")

if (addressInput) {
  const inputOutline = addressInput.dataset.outline;

  if (inputOutline === 'true') {
    addressInput.addEventListener('input', function () {
      addressInput.dataset.outline = false;
    });
  }
}

var inputsChanged = [false];

function checkInputs() {
  inputsChanged[0] = addressInput.value.trim() !== '' && addressInput.getAttribute("addressHasNumber") !== "false";
  console.log("checkInputs", inputsChanged[0]);
  var areaSpan = sessionStorage.getItem('roof_area');
  var areaNumber = Number(areaSpan)
  // enable continue button after start meassure 
  var continueBtn = document.getElementById("continueBtn");

  if (inputsChanged.every(Boolean) && areaNumber > 0) {
    // All three inputs have changed and have values and  meassure  have value too 
    console.log("All inputs have changed and have values.");
    if (!!continueBtn) {
      continueBtn.setAttribute("isallchange", "true");
      continueBtn.addEventListener("click", changePrice);
      continueBtn.addEventListener("click", function () {
        var header = document.querySelector('.header');
        if (header) {
          header.classList.remove("sticky-top");
        }
      });
    }
    for (var i = 0; i < inputsChanged.length; i++) {
      document.querySelector(`[popupinput${i + 1}]`).style.border = "1px solid #C6C6C6"
    }

    if (meassure_instructions) {
      meassure_instructions.style.border = "unset";
    }
  } else if (inputsChanged.every(Boolean)) {
    for (var i = 0; i < inputsChanged.length; i++) {
      document.querySelector(`[popupinput${i + 1}]`).style.border = "1px solid #C6C6C6"
    }

    if (meassure_instructions) {
      meassure_instructions.style.border = "1px solid #C6C6C6";
    }

  }

  else {
    for (var i = 0; i < inputsChanged.length; i++) {
      if (!inputsChanged[i]) {
        console.log('Input ' + (i + 1) + ' needs a value.');
        if (i + 1 == 1) {
          var checkMarkIcon = document.querySelector(".pac-input-check-icon");
          if (checkMarkIcon) {
            checkMarkIcon.classList.add("hidden");
          }
        }
        // document.querySelector(`[popupinput${i + 1}]`).style.border = "solid 2px red";
        continueBtn.setAttribute("isallchange", "false");
      }
      else {
        document.querySelector(`[popupinput${i + 1}]`).style.border = "1px solid #C6C6C6"


      }
    }
  }
}



// Add event listeners to track changes in each input
if (!!addressInput) {
  addressInput.addEventListener("change", checkInputs);
}


// function to change price in sticky bar on varinat change 

var variants_btns = document.querySelectorAll('input[varinatprice]');
var quantityButtons = document.querySelectorAll(".quantity-selector__button");
var total_price_text_with_downpayment = document.querySelector("#total_price_text_with_downpayment")
if (!!variants_btns) {

  // function to change configurationSavedText in PDP on varinat change 
  var configurationSavedText = document.querySelector(".configurationSavedText");
  var saveConfigText = document.querySelector(".saveConfigText");
  var saveConfigsvg = document.querySelector(".saveConfigsvg");

  if (configurationSavedText) {
    var userhasconfigsaved = configurationSavedText.getAttribute("userhasconfigsaved");
    for (let i = 0; i < variants_btns.length; i++) { variants_btns[i].addEventListener("click", changeConfigurationSavedText); };
    for (let i = 0; i < quantityButtons.length; i++) { quantityButtons[i].addEventListener("click", changeConfigurationSavedText); };
    function changeConfigurationSavedText(e) {
      const saveSetupButton = document.getElementById('saveConfigWrapper');
      saveSetupButton.setAttribute('data-saved', false);

      var saveConfigTextValue = document.querySelector(".configurationSavedText").getAttribute("saveConfigText");
      if (saveConfigText && saveConfigsvg) {
        saveConfigText.innerText = `${saveConfigTextValue}`
        saveConfigsvg.style.fill = "none"
      }
    }
  }

  for (let i = 0; i < variants_btns.length; i++) { variants_btns[i].addEventListener("click", changePrice); };
  function changePrice() {

    var currentCurrencySymbol = "€"
    var stickyPrice = document.querySelector(".stickyPrice");
    var stickyPrice_selling = document.querySelector(".stickyPrice_selling");
    var monthelyStickyPrice = document.querySelector("#mothely_price");
    if (!!stickyPrice) {
      var stickyPriceRow = stickyPrice.getAttribute("totalprice");
      var varinatPrics = document.querySelectorAll('input[varinatprice]:checked');
      let newPrice = parseInt(stickyPriceRow);
      varinatPrics.forEach(function (variant) {
        var variantPrice = parseInt(variant.getAttribute("varinatprice"));
        newPrice += variantPrice;
      });
      var PriceFormat = (newPrice / 100).toLocaleString('de', { style: 'decimal', minimumFractionDigits: 0, maximumFractionDigits: 2 });

      // function to calculat mothely price 
      var totalPriceinEuro = newPrice / 100
      var monthelyPriceinEuro = Math.floor(totalPriceinEuro / 25 / 12)
      var monthelyPriceFormat = monthelyPriceinEuro.toLocaleString('de', { style: 'decimal', minimumFractionDigits: 0, maximumFractionDigits: 2 });
      monthelyStickyPrice.innerHTML = `${currentCurrencySymbol}${monthelyPriceFormat}`

      // handle change price in sticy with selling_plan_checked

      var paymentMethodsInputs = document.querySelectorAll(".payment-method-option-input")
      if (!areChangeEventsAttachedToPaymentOptionsFlag && paymentMethodsInputs.length > 0) {
        paymentMethodsInputs.forEach(input => {
          input.addEventListener('change', () => {
            changePrice();
          });
        });
        areChangeEventsAttachedToPaymentOptionsFlag = true;
      }

      document.addEventListener("DOMContentLoaded", changePrice);

      var continueBtn = document.querySelector(".next_step_BTN");

      continueBtn?.addEventListener('click', function (e) {
        var isallchange = continueBtn.getAttribute("isallchange")
        if (isallchange != "true") {
          return
        }

        changePrice();

        var quantityInput = document.querySelector(".quantity-selector__value");
        if (!window.stateManager) {
          const waitForStateManagerToGetPannelsQuantity = setInterval(() => {
            if (window.stateManager) {
              window.stateManager.pannelsQuantity.value = +quantityInput?.value;
              clearInterval(waitForStateManagerToGetPannelsQuantity);
            }
          }, 50);
        } else {
          window.stateManager.pannelsQuantity.value = +quantityInput?.value;
        }

        document.dispatchEvent(new CustomEvent('configurationModal:continue'));
      });
    }


    //changePriceOnQuantityChange for variants and sticky bar price 
    function changePriceOnQuantityChange() {

      var quantity_selector_product = document.querySelector(".quantity-selector--product");
      var quantityBtns = quantity_selector_product.querySelectorAll(".quantity-selector__button");


      for (let i = 0; i < quantityBtns.length; i++) {
        quantityBtns[i].addEventListener('click', function (e) {

          var selectedaddOnVariant = document.querySelectorAll('input[addquantitystatus="subscribeQuantityInput"]');
          var checkBtn = quantityBtns[i].getAttribute("data-action");
          var quantityInputValue = 0;
          if (checkBtn == "increase-picker-quantity") {
            quantityInputValue = Number(quantity_selector_product.querySelector("[name='quantity']").value) + 1;
          } else {
            quantityInputValue = Number(quantity_selector_product.querySelector("[name='quantity']").value) - 1;
          }

          if (!window.stateManager?.pannelsQuantity?.value) {
            const waitForStateManagerToGetPannelsQuantity = setInterval(() => {
              if (window.stateManager) {
                window.stateManager.pannelsQuantity.value = +quantityInputValue;
                clearInterval(waitForStateManagerToGetPannelsQuantity);
              }
            }, 50);
          } else {
            window.stateManager.pannelsQuantity.value = +quantityInputValue;
          }


          if (quantityInputValue <= 46) {
            for (let i = 0; i < selectedaddOnVariant.length; i++) {
              var modulPrice = selectedaddOnVariant[i].nextElementSibling.querySelector(".pro_Modul").getAttribute("pro_Modul") / 100;
              var newTotalPrice = (modulPrice * quantityInputValue);
              var PriceFormat = (newTotalPrice).toLocaleString('de', { style: 'decimal', minimumFractionDigits: 0, maximumFractionDigits: 2 });
              selectedaddOnVariant[i].setAttribute("varinatprice", `${newTotalPrice * 100}`);
              selectedaddOnVariant[i].nextElementSibling.querySelector(".AddOnPrice").innerText = `  + €${PriceFormat}`;
            }
            changePrice()
          }
          if (quantityInputValue) {
            kilowattPeakCalc(quantityInputValue);
          }
        })
      }
      if (Number(quantity_selector_product.querySelector("[name='quantity']").value)) {
        kilowattPeakCalc(Number(quantity_selector_product.querySelector("[name='quantity']").value));
      }
    }



    function changePriceOnQuantityChangeinput() {
      var quantity_selector_product = document.querySelector(".quantity-selector--product")
      var quantityInput = quantity_selector_product.querySelector(".quantity-selector__value")
      var selectedaddOnVariant = document.querySelectorAll('input[addquantitystatus="subscribeQuantityInput"]');



      quantityInput.addEventListener('onkeyup', function (e) {

        var inputValue = parseFloat(this.value);

        // If the input value is greater than the max, set it to the max
        if (inputValue > 46) {
          this.value = 46;
        }
        if (!window.stateManager) {
          const waitForStateManagerToGetPannelsQuantity = setInterval(() => {
            if (window.stateManager) {
              window.stateManager.pannelsQuantity.value = +inputValue;
              clearInterval(waitForStateManagerToGetPannelsQuantity);
            }
          }, 50);
        } else {
          window.stateManager.pannelsQuantity.value = +inputValue;
        }
      })
      quantityInput.addEventListener('change', function (e) {

        var quantityInputValue = this.value;
        if (quantityInputValue > 46) {
          quantityInput.value = 46;
          quantityInputValue = 46;
          quantityInput.innerText = 46;

        }
        for (let i = 0; i < selectedaddOnVariant.length; i++) {
          var modulPrice = selectedaddOnVariant[i].nextElementSibling.querySelector(".pro_Modul").getAttribute("pro_Modul") / 100;
          var newTotalPrice = (modulPrice * quantityInputValue)
          var PriceFormat = (newTotalPrice).toLocaleString('de', { style: 'decimal', minimumFractionDigits: 0, maximumFractionDigits: 2 });
          selectedaddOnVariant[i].setAttribute("varinatprice", `${newTotalPrice * 100}`)
          selectedaddOnVariant[i].nextElementSibling.querySelector(".AddOnPrice").innerText = `  + €${PriceFormat}`
        }
        changePrice()
        if (quantityInputValue) {
          kilowattPeakCalc(quantityInputValue);
        }
        if (!window.stateManager) {
          const waitForStateManagerToGetPannelsQuantity = setInterval(() => {
            if (window.stateManager) {
              window.stateManager.pannelsQuantity.value = +quantityInputValue;
              clearInterval(waitForStateManagerToGetPannelsQuantity);
            }
          }, 50);
        } else {
          window.stateManager.pannelsQuantity.value = +quantityInputValue;
        }
      })

      document.dispatchEvent(new CustomEvent('stateInitDone'))

    }


    function attachEventsForGettingPannelsQuantity() {
      var qtyButtons = document.querySelector(".quantity-selector__button");
      var quantityInput = document.querySelector(".quantity-selector__value");

      if (qtyButtons) {
        Array.from(qtyButtons).forEach(btn => {
          btn.addEventListener("click", (e) => {
            if (!window.stateManager) {
              const waitForStateManagerToGetPannelsQuantity = setInterval(() => {
                if (window.stateManager) {
                  window.stateManager.pannelsQuantity.value = +quantityInput?.value;
                  clearInterval(waitForStateManagerToGetPannelsQuantity);
                }
              }, 50);
            } else {
              window.stateManager.pannelsQuantity.value = +quantityInput?.value;
            }
          });
        });
      }

      if (quantityInput) {
        quantityInput.addEventListener('change', () => {
          if (!window.stateManager) {
            const waitForStateManagerToGetPannelsQuantity = setInterval(() => {
              if (window.stateManager) {
                window.stateManager.pannelsQuantity.value = +quantityInput?.value;
                clearInterval(waitForStateManagerToGetPannelsQuantity);
              }
            }, 50);
          } else {
            window.stateManager.pannelsQuantity.value = +quantityInput?.value;
          }
        });
      }

      if (!window.stateManager) {
        const waitForStateManagerToGetPannelsQuantity = setInterval(() => {
          if (window.stateManager) {
            window.stateManager.pannelsQuantity.value = +quantityInput?.value;
            clearInterval(waitForStateManagerToGetPannelsQuantity);
          }
        }, 50);
      } else {
        window.stateManager.pannelsQuantity.value = +quantityInput?.value;
      }
    }

    document.addEventListener('DOMContentLoaded', function (e) {
      attachEventsForGettingPannelsQuantity();

      var isItsolarPanalConfig = document.querySelector(".metaobject_option_wrapper");
      if (!!isItsolarPanalConfig) {
        changePriceOnQuantityChange()
        changePriceOnQuantityChangeinput()
      }
    });

    //check data from popup in pdp
    var CheckSesstionStoragekw = sessionStorage.getItem('avg_electricity_use_per_year_kwh');
    var CheckSesstionStoragekm = sessionStorage.getItem('km_pro_year');

    var CheckSesstionStorageroof_area = sessionStorage.getItem('roof_area');
    var roof_area = document.querySelector("#roof_area");
    var Power_consumption = document.querySelector("#Power_consumption");
    var year_kilo = document.querySelector("#year_kilo");
    if (!!CheckSesstionStoragekw && !!Power_consumption && !!CheckSesstionStoragekm && !!year_kilo) {
      Power_consumption.innerText = CheckSesstionStoragekw;
      year_kilo.innerText = CheckSesstionStoragekm;
    }
    if (!!CheckSesstionStorageroof_area && !!roof_area) {
      roof_area.innerText = CheckSesstionStorageroof_area;

    }

    // handle open popup button

    var openPopupBtn = document.getElementById("openPopupBtn")
    if (!!openPopupBtn) {
      openPopupBtn.addEventListener('click', function () {
        var continueBtn = document.querySelector("#continueBtn")
        if (!!continueBtn) {
          continueBtn.setAttribute("isallchange", "false")
        }
        // check if SesstionStorage have values and add them back to inputs 
        var CheckSesstionStorageKW = sessionStorage.getItem('avg_electricity_use_per_year_kwh');
        var CheckSesstionStorageKM = sessionStorage.getItem('km_pro_year');
        if (CheckSesstionStorageKW !== "" || !!CheckSesstionStorageKW && CheckSesstionStorageKW !== "" || !!CheckSesstionStorageKW) {
          var kwInput = document.querySelector("#avg_electricity_use_per_year_kwh")
          var kmInput = document.querySelector("#km_pro_year")
          if (!!kwInput && !!kmInput) {
            kwInput.value = CheckSesstionStorageKW
            kmInput.value = CheckSesstionStorageKM
          }
        }
        var popupDiv = document.querySelector("[data-popup-settings]")
        popupDiv.setAttribute("aria-hidden", "false");
        document.querySelector('html').style.overflow = 'hidden';
        var header = document.querySelector('.header')
        header.classList.add("sticky-top")
        document.dispatchEvent(new CustomEvent("popup:reset"));
      })
    }

    /**
     * Calculation of kilowatt peak.
     * Formula: (qty * 410) / 1000
     * 
     * @param {string|number} qty - The quantity to calculate kilowatt peak. Should be either a string or a number.
     */
    function kilowattPeakCalc(qty) {
      let quantity = parseInt(qty);
      let kilowattPeak = (quantity * 410) / 1000;
      if (quantity <= 46) {
        updateKilowattPeakValueInDOM(kilowattPeak);
      }
    }

    /**
     * Changing a DOM for kilowatt peak.
     * 
     * @param {number} killowattPeak
     */
    function updateKilowattPeakValueInDOM(killowattPeak) {
      const kilowattPeakElement = document.querySelectorAll('#kilowatt-peak');
      if (!kilowattPeakElement && !kilowattPeakElement.childNodes[0]) return;

      if (!window.stateManager) {
        const waitForStateManagerToGetKilowattPeak = setInterval(() => {
          if (window.stateManager) {
            window.stateManager.kilowattPeak.value = killowattPeak;
            clearInterval(waitForStateManagerToGetKilowattPeak);
          }
        }, 50);
      } else {
        window.stateManager.kilowattPeak.value = killowattPeak;
      }

      kilowattPeakElement.forEach(el => {
        el.childNodes[0].nodeValue = killowattPeak + ' ';
      })
    }
  }
  changePrice();

}

function scrollToElement(elementId) {
  const element = document.getElementById(elementId);
  if (element) {
    element?.scrollIntoView();
  } else {
    console.error("Element with ID", elementId, "not found.");
  }
}

function scrollToElement(elementId) {
  const element = document.getElementById(elementId);
  if (element) {
    element?.scrollIntoView();
  } else {
    console.error("Element with ID", elementId, "not found.");
  }
}

function saveConfig(btn) {
  const atcHiddenButton = document.querySelector('#add-to-cart-product--hidden');
  const saveSetupWrapper = document.getElementById('saveConfigWrapper');
  const mvtErrorMsg = document.getElementById('error-message-calendar');
  const mvtInputWrapper = document.getElementById('mvt_calendar_input_wrapper');
  const hpInputWrapper = document.getElementById('hp_calendar_input_wrapper');
  let Is_mvt_phone_input = document.getElementById('mvt_phone_input');




  var userConfig = {};
  var module_number = Number(document.querySelector('[name="quantity"]').value);
  var kilowattPeak = Number(document.querySelector("#kilowatt-peak").innerText.replace(/[a-zA-Z]/g, ''))
  var customerId = document.querySelector(".customerId").value;
  userConfig["module_number"] = module_number;
  var metaobject_options = document.querySelectorAll(".metaobject_option_wrapper");

  // check if there's mvt_phone_input to add the value of it to userConfig["mvt_phone"] 
  if (Is_mvt_phone_input) {
    const selectedContryCode = document.querySelector('.iti__selected-dial-code').innerText;
    const mvtPhoneInputValue = document.getElementById('mvt_phone_input').value;
    //if we have only country this must be null
    let mvtPhoneInput = mvtPhoneInputValue != '' ? `${selectedContryCode} ${mvtPhoneInputValue}` : null;
    //set in user data the booked date phone
    userConfig["mvt_phone"] = mvtPhoneInput || null
  }


  // TODO: This needs some rework - config needs to be saved and merged with solar in gcloud 
/*
  if (template === 'heat-pump') {
    sessionStorage.setItem('userSetup', JSON.stringify(
      {
        "userConfig": {
          "userQuestionnaire": {}
        },
        "customerId": `${customerId}`
      }
    ));
    atcHiddenButton.click();
    return
  }
 */

  for (let i = 0; i < metaobject_options.length; i++) {
    var optionName = metaobject_options[i].getAttribute("option-name");
    if (!!metaobject_options[i].querySelector(`input[type="radio"]:checked`)) {
      var currentSelected = metaobject_options[i].querySelector(`input[type="radio"]:checked`).getAttribute("titleofaddon");
      userConfig[`${optionName}`] = currentSelected;
    }
  }

  var pdpCalendarError = false
  // check if url params has mvt_booked in this case we stop validation for mvt_calendar_profi_check
  const urlSearchParams = new URLSearchParams(window.location.search);
  var mvt_booked_exists = urlSearchParams.has('mvt_booked');

  //set in user data the booked date
  userConfig["mvt_booked"] = sessionStorage.getItem("mvt_booked") || null
  //if the mvt_booked date isnt set we scroll to the calendar input and force to add a date

  
  if (template === 'heat-pump') {
    if (!sessionStorage.getItem("hp_booked")) {
      scrollToElement("mvt_calendar_profi_check");
      mvtErrorMsg?.classList.remove('hidden');
      hpInputWrapper?.classList.add('error');
      //retoggle the questionaire once we changed date here
      setCookie('CalendarWasShown', false, 3);
      console.log('No date selected');
      pdpCalendarError = true
    }

  }
  else{
    if (!userConfig["mvt_booked"] && document.getElementById('mvt_calendar_profi_check') && !mvt_booked_exists) {
      scrollToElement("mvt_calendar_profi_check");
      mvtErrorMsg?.classList.remove('hidden');
      mvtInputWrapper?.classList.add('error');
      //retoggle the questionaire once we changed date here
      setCookie('CalendarWasShown', false, 3);
      console.log('No date selected');
      pdpCalendarError = true
    }
  }


   // check if url params has mvt_booked in this case we stop validation for mvt_phone_input
  //if the mvt_booked date isnt set we scroll to the calendar input and force to add a date
  if (!userConfig["mvt_phone"] && userConfig["mvt_booked"] && document.getElementById('mvt_phone_input_wrapper') && !mvt_booked_exists) {
    scrollToElement("mvt_phone_input_wrapper");
    // mvtPhoneErrorMsg?.classList.remove('hidden');
    // mvtPhoneInput?.classList.add('error');
    //retoggle the questionaire once we changed date here
    setCookie('CalendarWasShown', false, 3);
    pdpCalendarError = true
  }

  if (pdpCalendarError) {
    return
  }

  if (btn === 'atcBtn' || btn === "atcCalendarBtn") {
    document.dispatchEvent(new CustomEvent('spinner:start'));
  }

  const dataFromQuestionnaire = sessionStorage.getItem('questionnaireData');
  const parsedDataFromQuestionnaire = dataFromQuestionnaire ? JSON.parse(dataFromQuestionnaire) : null;

  console.log('✌️userConfig.Montageleistung --->', userConfig.Montageleistung);
  console.log('✌️userConfig.Wallbox --->', userConfig.Wallbox);
  console.log('✌️userConfig.Batteriespeicher --->', userConfig.Batteriespeicher);
  console.log('✌️userConfig.Modultyp --->', userConfig.Modultyp);
  console.log('✌️userConfig.module_number --->', userConfig.module_number);
  console.log('✌️customerId --->', customerId);


  // updating the input quantity when the page is first rendered
  if (userConfig.module_number) {
    const quantityValue = document.querySelector(".quantity-selector__value");
    quantityValue.value = userConfig.module_number;
  }

  let postData = {}
  if (template === 'heat-pump') {
     postData = {
      "userConfig": {

        "hp_booked": `${sessionStorage.getItem("hp_booked")}`,
        "hp_booked_timestamp": `${sessionStorage.getItem("hp_booked_timestamp")}`,
        "hp_phone": `${userConfig.mvt_phone}`
      },
      "customerId": `${customerId}`
    }
  }else{
    postData = {
      "userConfig": {
        "module_number": `${userConfig.module_number}`,
        "Modultyp": `${userConfig.Modultyp}`,
        "Batteriespeicher": `${userConfig.Batteriespeicher}`,
        "Wallbox": `${userConfig.Wallbox}`,
        "Montageleistung": `${userConfig.Montageleistung}`,
        "kWp": `${kilowattPeak}`,
        "mvt_booked": `${sessionStorage.getItem("mvt_booked")}`,
        "mvt_booked_timestamp": `${sessionStorage.getItem("mvt_booked_timestamp")}`,
        "mvt_phone": `${userConfig.mvt_phone}`,
        "userQuestionnaire": {
          "roofType": parsedDataFromQuestionnaire?.roofType || '',
          "roofWindows": parsedDataFromQuestionnaire?.roofWindows || '',
          "roofCovering": parsedDataFromQuestionnaire?.roofCovering || '',
          "nonFixedRoofTiles": parsedDataFromQuestionnaire?.nonFixedRoofTiles || '',
          "houseOwner": parsedDataFromQuestionnaire?.houseOwner || '',
          "houseOwnersList": parsedDataFromQuestionnaire?.houseOwnersList || '',
        }
      },
      "customerId": `${customerId}`
    }

  }


  if (!Is_mvt_phone_input) {
    //remove from postData object mvt_booked and mvt_phone and mvt_booked_timestamp in case user with tag mvt_booked or mvt_done 
    // to not overwrite in the user metaobject with mvt_phone null 
    delete postData.userConfig.mvt_booked;
    delete postData.userConfig.mvt_phone;
    delete postData.userConfig.mvt_booked_timestamp;
  }
  sessionStorage.setItem('userSetup', JSON.stringify(postData));
  // Send MVT Date + Phone number + userEmail to Endpoint when user books an MVT via the PDP
  sendMvtDate(userConfig)
  if (saveSetupWrapper && saveSetupWrapper.getAttribute('data-saved') == 'false') {
    //send data only if data is there for setup
    console.log('✌️postData --->', postData);

    if (customerId && userConfig.module_number && userConfig.Modultyp && userConfig.Montageleistung || template === 'heat-pump') {
      fetch('https://us-central1-enpal-function.cloudfunctions.net/save-customer-setup', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(postData),
      })
        .then(response => {
          response = response.text();
          return response;
        })
        .then(data => {
          saveSetupWrapper.setAttribute('data-saved', true);
          var saveConfigText = document.querySelector(".saveConfigText");
          var saveConfigsvg = document.querySelector(".saveConfigsvg");
          var configurationSavedText = document.querySelector(".configurationSavedText").getAttribute("configurationSavedText");
          if (saveConfigText && saveConfigsvg) {
            saveConfigText.innerText = `${configurationSavedText}`
            saveConfigsvg.style.fill = "#072543"
          }
          console.log(btn);
          //toggles a hidden ATC button if it's add to cart Button 
          if (btn == "atcBtn" || btn == "atcCalendarBtn") {
            atcHiddenButton.click();
          }

        })
        .catch(error => {
          console.error('Error:', error)
          atcHiddenButton.click();
        });
    }
  } else {
    if (btn == "atcBtn" || btn == "atcCalendarBtn") {
      atcHiddenButton.click();
    }
  }
}


// Send MVT Date + Phone number + userEmail to Endpoint when user books an MVT via the PDP

function sendMvtDate(userConfig) {
  const urlSearchParams = new URLSearchParams(window.location.search);
  // Check if a parameter exists and if any is true we will block signup
  var roof_area_exists = urlSearchParams.has('roof_area');
  var electricity_exists = urlSearchParams.has('avg_electricity_use_per_year_kwh');
  var km_exists = urlSearchParams.has('km_pro_year');
  var customerKlaviyoId = urlSearchParams.has('id');
  var referrer_match = (document.referrer == 'https://app.enpal24.de/' || document.referrer == 'https://dev-enpal24.vercel.app/') ? true : false;
  var isUserWithUrlPrameters = roof_area_exists && electricity_exists && km_exists && customerKlaviyoId && referrer_match 

  let userEmail = document.querySelector(".customerEmail");
  let mvt_date = sessionStorage.getItem("mvt_booked");
  let hp_date = sessionStorage.getItem("hp_booked");
  let user_phone = sessionStorage.getItem("phoneNumber");
  let isLoginCustomer = false
  if (userEmail && mvt_date && !customerKlaviyoId ) {
    isLoginCustomer = true
  }

  if (userEmail && hp_date && !customerKlaviyoId ) {
    isLoginCustomer = true
  }

  // check if UTM saved to sessionStorage to add it to postData object we send in API post 
  let UTMsessionStorage = sessionStorage.getItem("UTM");
  if (UTMsessionStorage) {
    UTMsessionStorage =   JSON.parse(UTMsessionStorage)
  }
    let postDataMvt = {}
    let apiUrl="";
    if (isLoginCustomer) {
      if (template === 'heat-pump') {
        apiUrl ="https://375wktcgp7.execute-api.eu-central-1.amazonaws.com/prod/hp-booking"
        postDataMvt = {
          "email": `${userEmail.value}`,
          "hp_booked": `${hp_date}`,
          "phone": `${user_phone}`,
        }
      }
      else{
          apiUrl ="https://375wktcgp7.execute-api.eu-central-1.amazonaws.com/prod/mvt-booking"
        postDataMvt = {
          "email": `${userEmail.value}`,
          "mvt_booked": `${mvt_date}`,
          "phone": `${user_phone}`,
        }

      }
      // check if UTM saved to sessionStorage to add it to postData object we send in API post 
      if (UTMsessionStorage) {
        postDataMvt = { ...UTMsessionStorage, ...postDataMvt };
      }
    }
    else if (isUserWithUrlPrameters) {
       apiUrl ="https://375wktcgp7.execute-api.eu-central-1.amazonaws.com/prod/update-profile";
      sessionStorage.setItem("customerKlaviyoId" ,`${urlSearchParams.get('id')}`)
      postDataMvt = {
        "event": "atcEvent",
        "id": `${urlSearchParams.get('id')}`,
        "module_number": `${userConfig.module_number}`,
        "Modultyp": `${userConfig.Modultyp}`,
        "Batteriespeicher": `${userConfig.Batteriespeicher}`,
        "Wallbox": `${userConfig.Wallbox}`,
        "Montageleistung": `${userConfig.Montageleistung}`,
        "mvt_booked": `${sessionStorage.getItem("mvt_booked")}`,
        "mvt_booked_timestamp": `${sessionStorage.getItem("mvt_booked_timestamp")}`,
        "mvt_booked": `${mvt_date}`,
      }
          // check if UTM saved to sessionStorage to add it to postData object we send in API post 
    if (UTMsessionStorage) {
      postDataMvt = { ...UTMsessionStorage, ...postDataMvt };
    }
    }

    fetch(`${apiUrl}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(postDataMvt),
    })
      .then(response => {
        if (response.ok) {
          console.log('postDataMvt Done')
        }
      })
      .catch(error => {
        console.error('Error:', error)
      });
}

//main listeners for save config && atc to toggle the saving of config as well
const saveConfigWrapper = document.querySelector('#saveConfigWrapper');
const atcBtn = document.querySelector('#add-to-cart-button');
const atcCalendarBtn = document.querySelector('#calendar_atc');
let inputTelefoneCalendar = document.getElementById("mvt_phone_input");
const phoneValidationError = document.getElementById('error-msg');
const errorMsgTextCalendar = window.numberValidation.errorText;
const numberRequired = true;
const errorTextNumberRequired = window.numberValidation.errorTextNumberRequired;


const atcBtnHandle = (btn) => {
  const urlSearchParams = new URLSearchParams(window.location.search);
  var mvt_booked_exists = urlSearchParams.has('mvt_booked');
  if (template === 'heat-pump') {
    saveConfig(btn);
  }
  else if (mvt_booked_exists && inputTelefoneCalendar ){
    inputTelefoneCalendar.removeAttribute("required")
    saveConfig(btn);
  }
   else {
    if (numberRequired && inputTelefoneCalendar) {
      if (inputTelefoneCalendar && document.getElementById("mvt_phone_input").value) {
        phoneValidationError.innerText = '';
        saveConfig(btn);
      } else if (inputTelefoneCalendar.value === '') {
        phoneValidationError.innerText = errorTextNumberRequired;
        if (inputTelefoneCalendar) {
          var mvt_phone_input_wrapper = document.getElementById("mvt_phone_input_wrapper");
          if (mvt_phone_input_wrapper) {
            mvt_phone_input_wrapper.classList.remove("form__input-wrapper-hide");
          }
          scrollToElement("mvt_phone_input_wrapper")
        }
      } else {
        phoneValidationError.innerText = errorMsgTextCalendar;
      }
    } else if (inputTelefoneCalendar) {
      if (inputTelefoneCalendar.value === '' && !numberRequired) {
        phoneValidationError.innerText = '';
        saveConfig(btn);
      } else if (document.getElementById("mvt_phone_input").value && !numberRequired) {
        phoneValidationError.innerText = '';
        saveConfig(btn);
      } else {
        phoneValidationError.innerText = errorMsgTextCalendar;
      }
    } else {
      saveConfig(btn);
    }
  }
}

saveConfigWrapper?.addEventListener('click', (e) => {
  atcBtnHandle(e);
});

atcBtn?.addEventListener('click', (e) => {
  atcBtnHandle("atcBtn");
});

atcCalendarBtn?.addEventListener('click', (e) => {
  atcBtnHandle("atcBtn");
});



// function to send new address to metafield and open Questionnaire popup again 
var customerAddressbtn = document.querySelector('button[customeraddress]');
if (customerAddressbtn) {
  customerAddressbtn.addEventListener('click', (e) => {
    var newAddressInputValue = document.querySelector("#pac-input").value
    var currentAddress = sessionStorage.getItem("addressFromCustomerMeta");
    var customerId = document.querySelector(".customerId").value;
    if (newAddressInputValue != currentAddress) {
      console.log("address  change ");
      setCookie('isQuestionnaireCompleted', false, 3);

      // add module_numberFrom_Metafield in PDP 0 so it's not overwrite on the new calculation  
      var checkIfSavedpanelsnumber = document.querySelector("[module_number_saved]");
      if (checkIfSavedpanelsnumber) {
        checkIfSavedpanelsnumber.setAttribute("module_number_saved", "0");
      }
    }
    document.dispatchEvent(new CustomEvent('customerAddress:changed',));
  });
}

// Function that's checking if session storage was changed.
// Detect only next keys: pac-input, avg_electricity_use_per_year_kwh, km_pro_year
function checkIfSessionStorageWasChanged() {
  let sessionStorageWasChanged = false;
  const initialState = JSON.parse(sessionStorage.getItem('popupInitialState'));
  const newState = { ...initialState };

  // We don't run into next steps beacause popup was open initially. We need to run only when values was changed.
  if (initialState.address === null) return;

  const newAddressValue = sessionStorage.getItem('pac-input');
  const newElectricityValue = +sessionStorage.getItem('avg_electricity_use_per_year_kwh');
  const newKilometersValue = +sessionStorage.getItem('km_pro_year');

  if (initialState.address !== newAddressValue) {
    sessionStorageWasChanged = true;
    newState.address = newAddressValue;
    sessionStorage.setItem('popupInitialState', JSON.stringify(newState));
  }

  if (initialState.electricity !== newElectricityValue) {
    sessionStorageWasChanged = true;
    newState.electricity = newElectricityValue;
    sessionStorage.setItem('popupInitialState', JSON.stringify(newState));
  }

  if (initialState.kilometers !== newKilometersValue) {
    sessionStorageWasChanged = true;
    newState.kilometers = newKilometersValue;
    sessionStorage.setItem('popupInitialState', JSON.stringify(newState));
  }

  if (sessionStorageWasChanged) {
    document.dispatchEvent(new CustomEvent('sessionStorage:changed', {
      detail: {
        address: {
          key: 'pac-input',
          oldValue: initialState.address,
          newValue: newState.address
        },
        electricity: {
          key: 'avg_electricity_use_per_year_kwh',
          oldValue: initialState.electricity,
          newValue: newState.electricity
        },
        kilometers: {
          key: 'km_pro_year',
          oldValue: initialState.kilometers,
          newValue: newState.kilometers
        }
      }
    }));
  }
}

function setCustomerConfigurationMetafield(event) {
  const customerId = document.querySelector(".customerId").value;
  if (!customerId) return;

  const postData = {
    "userAddress": `${event.detail.address.newValue}`,
    "userElectricity": `${event.detail.electricity.newValue}`,
    "userKilometers": `${event.detail.kilometers.newValue}`,
    "customerId": `${customerId}`
  };

  fetch('https://us-central1-enpal-function.cloudfunctions.net/update-customer-configurator', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(postData),
  })
    .catch((error) => {
      console.error('Error:', error)
    });
}

const popupContinueButton = document.getElementById('continueBtn');
popupContinueButton?.addEventListener('click', checkIfSessionStorageWasChanged);

document.addEventListener('sessionStorage:changed', function (event) {
  setCustomerConfigurationMetafield(event);
})

document.addEventListener('DOMContentLoaded', () => {
  if (addressFieldEl) {
    removeAddressOutline(addressFieldEl);
  }
});

if (openPopupButtonEl && addressFieldEl) {
  openPopupButtonEl.addEventListener('click', () => {
    removeAddressOutline(addressFieldEl);
  })
}

// remove plus animation from price-manager-toggler once clicked 
function removePlusAnimation() {
  var price_plus_btn = document.querySelector(".price-manager-toggler")
  if (price_plus_btn) {
    if (sessionStorage.getItem("removePlusAnimation") && price_plus_btn) {
      price_plus_btn.classList.remove('price-manager-toggler-plus');
    }
    else if (price_plus_btn.classList.contains('price-manager-toggler-plus')) {
      price_plus_btn.addEventListener("click", function () {
        this.classList.remove('price-manager-toggler-plus')
        sessionStorage.setItem("removePlusAnimation", "true")
      })
    }
  }
}
removePlusAnimation()

// checkHref to add UTM Param
function checkHref(event) {
  //(stop the redirection)
  event.preventDefault();
  var href = event.currentTarget.getAttribute('href');
  var UTMInStorage =  sessionStorage.getItem("UTM")
  if (href.includes("app.enpal24.de") && UTMInStorage) {
    UTMInStorage = JSON.parse(UTMInStorage)
     var queryStringArray = [];
    // Iterate through the keys of the object
     for (var key in UTMInStorage) {
    // Append each key-value pair in the required format
    queryStringArray.push(key + "=" + encodeURIComponent(UTMInStorage[key]));}
    // Join all key-value pairs with "&" 
    var queryString = queryStringArray.join("&");
    var hrefWithUtm = `${href}?${queryString}`
    window.location.href = hrefWithUtm;
  }else{
    window.location.href = href;
  }
}

